import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'graduate/courses/academic_calendars',
  label: 'Calendário acadêmico (cursos regulados)',
  actions: ['list', 'create', 'edit', 'delete'],
  parentName: 'course_creation',
  onlyPermission: true
};

export default generateResources(resource);
